const actions = {
    'notifyCustomer': 'Send email to customer about product availability',
    'showWatchDogButton': 'Show watch dog form',
};

export const getWatchDogActions = () => {
    return actions;
};

export const showWatchDogButtonAvailabilityFlag = 'showWatchDogButton';


// WEBPACK FOOTER //
// ../helpers/src/availability/watchDogActions.ts